import React from "react";
import Link from "next/link";
import LockedContentWrapper from "../../global/Wrappers/LockedContentWrapper";
import WinesTopContent from "./WinesTopContent";
import { useRouter } from "next/router";
import { useAuth } from "../../../context/authContext";
import { WinesTopEntry } from "../../../utils/wineRanking";

interface WineTopContentLockProps {
  description: string;
  wines: WinesTopEntry[];
}

const WinesTopContentLock = ({ description, wines }: WineTopContentLockProps) => {
  const router = useRouter();

  const {
    state: { user, loading },
  } = useAuth();

  const redirectToSignIn = () => {
    router.push({ pathname: "/users/sign_in", query: { from: router.asPath } });
  };
  return (
    <LockedContentWrapper
      message={
        <div className="space-y-4 text-center">
          <div className="flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-black"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
            <p className="pt-1 pl-3 text-2xl">Subscriber Access Only</p>
          </div>
          {!user ? (
            <p className="text-sm">
              <button onClick={() => redirectToSignIn()} className="text-red">
                Log In
              </button>{" "}
              or{" "}
              <Link href="/users/plan" className="text-red">
                Sign Up
              </Link>
            </p>
          ) : (
            <p className="text-sm">
              <Link href="/users/edit" className="text-red">
                Renew or Subscribe
              </Link>{" "}
              to access this content{" "}
            </p>
          )}
        </div>
      }
      placeholderContent={
        <div>
          <p className="pb-2">{description}</p>
        </div>
      }
    >
      <WinesTopContent description={description} wines={wines} />
    </LockedContentWrapper>
  );
};

export default WinesTopContentLock;
